import { Component, OnInit } from '@angular/core';
import { PickDropService } from 'src/app/services/pick-drop/pick-drop.service';
import { Storage } from '@ionic/storage';
import { ModalController } from '@ionic/angular';
import { PickDropDetailsPage } from 'src/app/pick-and-drop/pick-drop-details/pick-drop-details.page';

@Component({
  selector: 'app-pick-drop-history',
  templateUrl: './pick-drop-history.component.html',
  styleUrls: ['./pick-drop-history.component.scss'],
})
export class PickDropHistoryComponent implements OnInit {

  orders = [];
  showLoader = true;

  constructor(private pickDropService: PickDropService, private storage: Storage, private modalController: ModalController) { }

  async ngOnInit() {
    const userId = await this.storage.get('uid');
    const orders:any = await this.pickDropService.getOrders(userId);
    if (orders) {
      this.orders = orders;
      this.showLoader = false;
    }
    this.pickDropService.userOrdersSub.subscribe(orders => {
      this.orders = orders;
      console.log('orders:', orders);
    });
  }

  ngOnDestroy(): void {
    console.log('destroy');
    // this.pickDropService.userOrdersSub.unsubscribe();
    //this.pickDropService.getUserOrdersSub.unsubscribe();
  }
  
  async openDetails(orderDetails) {
    const modal = await this.modalController.create({
    component: PickDropDetailsPage,
    cssClass:'custom-modal',
    componentProps: { order: orderDetails }
    });
  
    await modal.present();
  
  }
}
